// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__SKNqr","text":"SelectPayment_text__3bO6s","title":"SelectPayment_title__35K0c","btn":"SelectPayment_btn__3yn23"};